import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const Testimonials = (props) => {
  const testimonialsRef = useRef(null);

  useEffect(() => {
    const elements = testimonialsRef.current.querySelectorAll('.testimonial');

    elements.forEach(el => {
      gsap.fromTo(
        el,
        { opacity: 0, scale: 0.9 },
        {
          opacity: 1,
          scale: 1,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
            end: "bottom top",
            scrub: 1, // Scrubs the animation to the scroll position
            onEnter: () => el.classList.add('active'),
            onLeave: () => el.classList.remove('active'),
            onEnterBack: () => el.classList.add('active'),
            onLeaveBack: () => el.classList.remove('active')
          }
        }
      );
    });
  }, [props.data]);

  return (
    <div id="testimonials" ref={testimonialsRef}>
      <div className="container">
        <div className="section-title text-center">
          <h2>What our clients say</h2>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  <div className="testimonial text-center">
                    <div className="testimonial-content">
                      <p>"{d.text}"</p>
                      <div className="testimonial-meta text-center"> - {d.name} </div>
                      <div className="testimonial-meta text-center"> {d.title} </div>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
